import { siteApiSlice } from "../../app/siteApiSlice";

export interface StudentTeacherImpersonationResultModel {
	errorCreatingStudentAccount: boolean;
	errorImpersonatingStudent: boolean;
	errorLoggingIntoTeacherAccount: boolean;
}

export const impersonationApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		signInAsStudent: build.query<StudentTeacherImpersonationResultModel | void, void>({
			query: () => `/SignIn/SignInAsStudent`,
		}),
		signInAsTeacher: build.query<StudentTeacherImpersonationResultModel | void, void>({
			query: () => `/SignIn/SignInAsTeacher`,
		}),
	}),
});

export const { useLazySignInAsStudentQuery, useLazySignInAsTeacherQuery } = impersonationApiSlice;
